import { Category } from 'models/category'

export const AllProductsResolver = {
    allProducts: () =>
        [
            {
                name: 'Doors',
                products: [
                    {
                        productStatus: 'Initial Submission',
                        listing: {
                            name: ' Listing',
                        },
                        metadata: {
                            updated: '2018-11-26T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: '"Lot Full" Signs',
                        sectionName: 'PREINSTALLATION MEETINGS',
                        description:
                            'Retain "Preinstallation Conference" Paragraph below if Work of this Section is extensive or complex enough to justify a conference.',
                    },
                    {
                        productStatus: 'Submission For Upgrade',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2020-01-02T21:03:32.0198263Z',
                        },
                        productType: '[Bag] [Cartridge]-Type Filters',
                        sectionName: 'QUALITY ASSURANCE',
                        description:
                            'Installer Qualifications: A qualified vegetated roof assembly Installer[, approved, authorized, or licensed by roofing-membrane manufacturer,] whose work has resulted in successful establishment of vegetated roofs.',
                    },
                    {
                        productStatus: 'Submission For Update',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-12-03T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/black-window-door.svg',
                        productType:
                            '[Bronze] [or] [Brass] Steam Safety Valves',
                        sectionName: 'DELIVERY, STORAGE, AND HANDLING',
                        description:
                            'Handle and store materials, and place equipment in a manner to avoid overloading roof structure or damaging roofing membrane.',
                    },
                    {
                        productStatus: 'Under Review',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-12-06T21:03:32.0198263Z',
                        },
                        productType: '19-INCH EQUIPMENT CABINETS',
                        sectionName: 'FIELD CONDITIONS',
                        description:
                            "Weather Limitations: Proceed with planting only when existing and forecasted weather conditions permit planting to be performed when optimum results may be obtained. Apply products during favorable weather conditions according to manufacturer's written instructions and warranty requirements.",
                    },
                    {
                        productStatus: 'Waiting Further Information',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-11-21T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: '1Seismic Masonry-Veneer Anchors',
                        sectionName:
                            'WARRANTY|Special Warranty for Vegetated Roof Assembly|Warranty Period',
                        description:
                            "When warranties are required, verify with Owner's counsel that warranties stated in this article are not less than remedies available to Owner under prevailing local laws.",
                    },
                ],
            },
            {
                name: 'Windows',
                products: [
                    {
                        productStatus: 'Under Additional Review',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2018-11-28T21:03:32.0198263Z',
                        },
                        productType:
                            'Accessible, Freestanding, Plumbed Eye/Face Wash Units,',
                        sectionName:
                            'WARRANTY|Special Warranty for Vegetated Roof Assembly|Warranty Period',
                        description:
                            'Verify available warranties and warranty periods for vegetated roof assembly and components. Insert start date in "Warranty Period" Subparagraph below according to local practice and the type of vegetated roof assembly required.',
                    },
                    {
                        productStatus: 'Approved for MasterSpec',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-10-02T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: 'ACCORDION FOLDING DOORS',
                        sectionName: 'VEGETATED ROOF ASSEMBLY COMPONENTS',
                        description: 'Revise paragraphs below to suit Project.',
                    },
                    {
                        productStatus: 'Approved for General Distribution',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-12-03T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/black-window-door.svg',
                        productType:
                            '[Bronze] [or] [Brass] Steam Safety Valves',
                        sectionName: 'DELIVERY, STORAGE, AND HANDLING',
                        description:
                            'Handle and store materials, and place equipment in a manner to avoid overloading roof structure or damaging roofing membrane.',
                    },
                    {
                        productStatus: 'Declined',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-12-06T21:03:32.0198263Z',
                        },
                        productType: 'Adjustable Blade Face Grille',
                        sectionName:
                            'VEGETATED ROOF ASSEMBLY COMPONENTS|Recycled Content',
                        description:
                            "Weather Limitations: Proceed with planting only when existing and forecasted weather conditions permit planting to be performed when optimum results may be obtained. Apply products during favorable weather conditions according to manufacturer's written instructions and warranty requirements.",
                    },
                ],
            },
            {
                name: 'Pipes',
                products: [
                    {
                        productStatus: 'Under Additional Review',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2018-11-28T21:03:32.0198263Z',
                        },
                        productType:
                            'Accessible, Freestanding, Plumbed Eye/Face Wash Units,',
                        sectionName:
                            'WARRANTY|Special Warranty for Vegetated Roof Assembly|Warranty Period',
                        description:
                            'Verify available warranties and warranty periods for vegetated roof assembly and components. Insert start date in "Warranty Period" Subparagraph below according to local practice and the type of vegetated roof assembly required.',
                    },
                    {
                        productStatus: 'Approved for MasterSpec',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-10-02T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: 'ACCORDION FOLDING DOORS',
                        sectionName: 'VEGETATED ROOF ASSEMBLY COMPONENTS',
                        description: 'Revise paragraphs below to suit Project.',
                    },
                    {
                        productStatus: 'Approved for General Distribution',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-12-03T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/black-window-door.svg',
                        productType:
                            '[Bronze] [or] [Brass] Steam Safety Valves',
                        sectionName: 'DELIVERY, STORAGE, AND HANDLING',
                        description:
                            'Handle and store materials, and place equipment in a manner to avoid overloading roof structure or damaging roofing membrane.',
                    },
                    {
                        productStatus: 'Declined',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-12-06T21:03:32.0198263Z',
                        },
                        productType: 'Adjustable Blade Face Grille',
                        sectionName:
                            'VEGETATED ROOF ASSEMBLY COMPONENTS|Recycled Content',
                        description:
                            "Weather Limitations: Proceed with planting only when existing and forecasted weather conditions permit planting to be performed when optimum results may be obtained. Apply products during favorable weather conditions according to manufacturer's written instructions and warranty requirements.",
                    },
                ],
            },
            {
                name: 'Floors',
                products: [
                    {
                        productStatus: 'Initial Submission',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2018-11-26T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: '"Lot Full" Signs',
                        sectionName: 'PREINSTALLATION MEETINGS',
                        description:
                            'Retain "Preinstallation Conference" Paragraph below if Work of this Section is extensive or complex enough to justify a conference.',
                    },
                    {
                        productStatus: 'Submission For Upgrade',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2020-01-02T21:03:32.0198263Z',
                        },
                        productType: '[Bag] [Cartridge]-Type Filters',
                        sectionName: 'QUALITY ASSURANCE',
                        description:
                            'Installer Qualifications: A qualified vegetated roof assembly Installer[, approved, authorized, or licensed by roofing-membrane manufacturer,] whose work has resulted in successful establishment of vegetated roofs.',
                    },
                    {
                        productStatus: 'Submission For Update',
                        listing: {
                            name: 'Premium Listing',
                        },
                        metadata: {
                            updated: '2019-12-03T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/black-window-door.svg',
                        productType:
                            '[Bronze] [or] [Brass] Steam Safety Valves',
                        sectionName: 'DELIVERY, STORAGE, AND HANDLING',
                        description:
                            'Handle and store materials, and place equipment in a manner to avoid overloading roof structure or damaging roofing membrane.',
                    },
                    {
                        productStatus: 'Under Review',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-12-06T21:03:32.0198263Z',
                        },
                        productType: '19-INCH EQUIPMENT CABINETS',
                        sectionName: 'FIELD CONDITIONS',
                        description:
                            "Weather Limitations: Proceed with planting only when existing and forecasted weather conditions permit planting to be performed when optimum results may be obtained. Apply products during favorable weather conditions according to manufacturer's written instructions and warranty requirements.",
                    },
                    {
                        productStatus: 'Waiting Further Information',
                        listing: {
                            name: 'Premium Propreitary Listing',
                        },
                        metadata: {
                            updated: '2019-11-21T21:03:32.0198263Z',
                        },
                        imageUrl:
                            'https://avitrucdn.azureedge.net/bpm/brown-window-door.svg',
                        productType: '1Seismic Masonry-Veneer Anchors',
                        sectionName: 'WARRANTY',
                        description:
                            "When warranties are required, verify with Owner's counsel that warranties stated in this article are not less than remedies available to Owner under prevailing local laws.",
                    },
                ],
            },
        ] as Category[],
}
